import React from "react"
import { Link } from "react-router-dom"
import { Container, Button } from "reactstrap"
import forbidden from "../../assets/images/forbidden.png"

const Forbidden = () => {
  return (
    <>
      <>
        <div className="page-content">
          <Container fluid>
            <React.Fragment>
              <div
                className={
                  "py-5 d-flex flex-column align-items-center justify-content-between"
                }
              >
                <img
                  src={forbidden}
                  style={{
                    maxWidth: "300px",
                  }}
                  alt="Record not found"
                />
                <h4
                  style={{
                    color: "#000000",
                    fontSize: "32px",
                    fontWeight: "600",
                    marginTop: "15px",
                    marginBottom: "5px",
                  }}
                >
                  {`403 - Access Denied`}
                </h4>
                <p
                  style={{
                    color: "#000000",
                    fontSize: "16px",
                  }}
                >
                  {`You don't have permission to view this page.`}
                </p>

                <div className="buttons">
                  <Link to={"/dashboard"}>
                    <Button type="button" className="primary">
                      Return to Dashboard
                    </Button>
                  </Link>
                </div>
              </div>
            </React.Fragment>
          </Container>
        </div>
      </>
    </>
  )
}

export default Forbidden
